"use client";
import { useScrollOpacity } from "@repo/lib/hooks/common";
import cx from "classnames";
import { usePathname } from "next/navigation";

const HeaderWrapper = ({ children }) => {
  const pathname = usePathname();

  const TRANSPARENT_ROUTES = {
    exact: ["/en", "/ar"],
    startsWith: [
      "/en/collection",
      "/ar/collection",
      "/en/spaces",
      "/ar/spaces",
    ],
  };
  const isScrollPathname =
    TRANSPARENT_ROUTES.exact.includes(pathname) ||
    TRANSPARENT_ROUTES.startsWith.some((route) => pathname.startsWith(route));

  const dynamicOpacity = useScrollOpacity(0.2, 1);
  const opacity = isScrollPathname ? dynamicOpacity : 1;

  return (
    <header
      className={cx("sticky top-0 z-50 px-4 py-3 md:py-5", {
        "-mb-[76px] md:-mb-[82px]": isScrollPathname,
      })}
      style={{
        backgroundColor: `rgba(27, 27, 27, ${opacity})`,
      }}
    >
      <div className="pointer-events-auto">{children}</div>
    </header>
  );
};

export default HeaderWrapper;
